<template>
    <div>
        <CompanyBoxContent :title="$t('company.yourEvents') + ':'">
            <template #data>
                <div v-if="events.length === 0" class="text-center box">
                    <span style="font-size: 16px;">{{ $t('company.noEvents') }}</span>
                </div>
                <div v-for="(event, index) in events" :key="event.id" class="box mb-3">
                    <div class="row align-items-center" :class="{ 'mt-2': index > 0 }">
                        <div class="col-6 col-md-7 col-xxl-9">
                            <div class="row align-items-center">
                                <div class="col-12 col-xxl-8 full_width">
                                    <div class="row full_width">
                                        <div class="col-12 full_width">
                                            <div class="container-fluid">
                                                <div class="row align-items-center">
                                                    <!-- Event-->
                                                    <div class="col-10">
                                                        <span style="font-size: 20px;" class="fw-bold">
                                                            {{ event.title }}
                                                        </span>
                                                        <span v-if="event.location" class="ms-2">
                                                            - {{ event.location }}
                                                        </span>
                                                    </div>

                                                    <!-- Edit / Delete buttons -->
                                                    <div class="col-2">
                                                        <div class="d-flex justify-content-between">
                                                            <button class="btn w-50 btn_edit me-2"
                                                                data-bs-toggle="modal" data-bs-target="#editEventModal"
                                                                @click="editEvent(event.slug)">
                                                                <icon icon="Edit"></icon>
                                                            </button>
                                                            <button class="btn w-50 btn_delete"
                                                                @click="deleteEvent(event.slug)">
                                                                <icon icon="Bin"></icon>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <!-- Datetime -->
                                                    <div class="col-12">
                                                        <span v-if="event.all_day" class="d-block fw-bold">
                                                            (Celodenní událost)
                                                        </span>
                                                        <span class="d-block">
                                                            <strong>Začátek:</strong>&nbsp;
                                                            {{ formatDateTime(event.start_time, event.all_day) }}
                                                        </span>
                                                        <span class="d-block">
                                                            <strong>Konec:</strong>&nbsp;
                                                            {{ formatDateTime(event.end_time, event.all_day) }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 text-center d-flex justify-content-center" data-bs-toggle="modal"
                    data-bs-target="#addEventModal">
                    <button class="btn btn_main">
                        <icon icon="Plus" class="me-2"></icon>
                        <span>{{ $t('general.addEvent') }}</span>
                    </button>
                </div>
            </template>
        </CompanyBoxContent>

        <!-- Modal for adding new event -->
        <div class="modal fade" id="addEventModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal_wrapper">
                    <div class="modal-header mx-auto border-0 pb-0">
                        <h3 class="modal-title title">{{ $t("general.addEvent") }}</h3>
                    </div>
                    <div class="modal-body">
                        <EventForm :event="newEvent" @submit="addEvent" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for editing event -->
        <div class="modal fade" id="editEventModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal_wrapper">
                    <div class="modal-header mx-auto border-0">
                        <h3 class="modal-title title">{{ $t("general.editEvent") }}</h3>
                    </div>
                    <div class="modal-body">
                        <EventForm :event="editingEvent" @submit="saveEditedEvent" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"
import EventForm from "@/components/EventForm.vue";

export default {
    props: {
        company: {
            type: Object,
            required: true
        },
        events: {
            type: Object,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
        EventForm
    },
    data() {
        return {
            newEvent: {
                title: "",
                description: "",
                location: "",
                allDay: false,
                startDate: "",
                startTime: "",
                endDate: "",
                endTime: ""
            },
            editingEvent: null,
            editingEventSlug: null,
        };
    },
    methods: {
        addEvent(eventData) {
            if (!eventData.title.trim() || !eventData.startDate || !eventData.endDate) {
                alert("Vyplňte povinná pole: Název, datum začátku a konce události");
                return; // Prevent adding empty event
            }

            // Set datetime format
            const full_start_time = eventData.allDay ? `${eventData.startDate}T00:00:00` : `${eventData.startDate}T${eventData.startTime}:00`;
            const full_end_time = eventData.allDay ? `${eventData.endDate}T23:59:00` : `${eventData.endDate}T${eventData.endTime}:00`;

            const formData = {
                title: eventData.title,
                description: eventData.description || null,
                location: eventData.location || null,
                all_day: eventData.allDay,
                start_time: full_start_time,
                end_time: full_end_time,
                slug: this.$route.params.slug,
            };

            this.$store.getters.api.post(`/event/add`, formData)
                .then(response => {
                    this.$emit("reload");
                })
        },
        deleteEvent(eventSlug) {
            this.$store.getters.api.delete(`/event/delete/${eventSlug}`)
                .then(response => {
                    this.$emit("reload");
                })
        },
        editEvent(eventSlug) {
            this.editingEventSlug = eventSlug;
            const event = this.events.find(event => event.slug === eventSlug);

            this.editingEvent = {
                slug: event.slug,
                title: event.title || "",
                description: event.description || "",
                location: event.location || "",
                allDay: event.all_day,
                startDate: event.start_time ? event.start_time.split("T")[0] : "",
                startTime: event.start_time ? event.start_time.split("T")[1].substring(0, 5) : "",
                endDate: event.end_time ? event.end_time.split("T")[0] : "",
                endTime: event.end_time ? event.end_time.split("T")[1].substring(0, 5) : ""
            };
        },
        saveEditedEvent(eventData) {
            const startDateTime = eventData.allDay
                ? `${eventData.startDate}T00:00:00`
                : `${eventData.startDate}T${eventData.startTime}:00`;

            const endDateTime = eventData.allDay
                ? `${eventData.endDate}T23:59:59`
                : `${eventData.endDate}T${eventData.endTime}:00`;

            const formData = {
                title: eventData.title,
                description: eventData.description,
                location: eventData.location,
                all_day: eventData.allDay,
                start_time: startDateTime,
                end_time: endDateTime,
                slug: this.$route.params.slug,
            };

            this.$store.getters.api.put(`/event/edit/${this.editingEventSlug}`, formData)
                .then(response => {
                    this.$emit("reload");
                    this.editingEvent = null;
                    this.editingEventSlug = null;
                })
        },
        formatDateTime(dateTime, allDay = false) {
            if (!dateTime) return "-";

            const date = new Date(dateTime);

            return new Intl.DateTimeFormat("cs-CZ", {
                timeZone: "Europe/Prague",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                ...(allDay ? {} : { hour: "2-digit", minute: "2-digit" })
            }).format(date);
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.btn_edit,
.btn_delete {
    color: $dark-purple;
    border: none;
    font-weight: 600;

    svg {
        stroke: $dark-purple;
        width: 30px;
        height: 30px;
    }
}

.modal_wrapper {
    position: relative;
    padding: 0px 5px;

    label {
        color: $white;
        font-weight: 700;
    }
}


@media screen and (max-width: 1700px) {
    .full_width {
        width: 100%;
    }
}
</style>